const months = [
  {
    month: 'January',
    text: '1',
    value: "01",
    days: 31,
  },
  {
    month: 'February',
    text: '2',
    value: "02",
    days: 28,
  },
  {
    month: 'March',
    text: '3',
    value: "03",
    days: 31,
  },
  {
    month: 'April',
    text: '4',
    value: "04",
    days: 30,
  },
  {
    month: 'May',
    text: '5',
    value: "05",
    days: 31,
  },
  {
    month: 'June',
    text: '6',
    value: "06",
    days: 30,
  },
  {
    month: 'July',
    text: '7',
    value: "07",
    days: 31,
  },
  {
    month: 'August',
    text: '8',
    value: "08",
    days: 31,
  },
  {
    month: 'September',
    text: '9',
    value: "09",
    days: 30,
  },
  {
    month: 'October',
    text: '10',
    value: "10",
    days: 31,
  },
  {
    month: 'November',
    text: '11',
    value: "11",
    days: 30,
  },
  {
    month: 'December',
    text: '12',
    value: "12",
    days: 31,
  },
]

export default months
